import { ConsumerHistory } from './consumer-history';
export class StaticConsumerHistory extends ConsumerHistory {
    constructor(context, historyKey, historyMultiplexer) {
        super(context, historyKey, historyMultiplexer);
        this.listen = this.listen.bind(this);
    }
    listen() {
        this.context.logger.warn('history.listen() is not supported.');
        return () => undefined;
    }
}
//# sourceMappingURL=static-consumer-history.js.map